import { getText } from '../../helpers';

type BookmarkItem = { keyId?: string | number | null };
type BookmarksData = {
    datasets?: BookmarkItem[];
    solutions?: BookmarkItem[];
    blueprints?: BookmarkItem[];
};

const toIdArray = (items?: BookmarkItem[]): string[] => ((items || [])
    .map(i => (i ? i.keyId : undefined))
    .filter((id): id is string | number => id !== undefined && id !== null && String(id).length > 0)
    .map(id => String(id)));

const generateCollectionFromBookmarks = (
    bookmarksData: BookmarksData | undefined
): Collection => {
    const name = getText('bookmark.text') || 'Bookmarks';
    const collectionId = 'bookmarks-collection';
    const description = '';

    const criteria: CollectionCriteria = {
        datasets: toIdArray((bookmarksData && bookmarksData.datasets) || []),
        bundles: [], // Bundles come under datasets in bookmarks, separated in collections API
        solutions: toIdArray((bookmarksData && bookmarksData.solutions) || []),
        blueprints: toIdArray((bookmarksData && bookmarksData.blueprints) || []),
    };

    const criteriaCount =
        criteria.datasets.length +
        criteria.solutions.length +
        criteria.blueprints.length;

    return {
        collectionId,
        name,
        description,
        criteriaCount,
        criteria,
        createdDate: '',
    };
};

export default generateCollectionFromBookmarks;
